import { render, staticRenderFns } from "./AppTopSpace.vue?vue&type=template&id=07814b8f&scoped=true"
import script from "./AppTopSpace.vue?vue&type=script&lang=js"
export * from "./AppTopSpace.vue?vue&type=script&lang=js"
import style0 from "./AppTopSpace.vue?vue&type=style&index=0&id=07814b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07814b8f",
  null
  
)

export default component.exports